import React from 'react';
import type { FormInstance } from 'antd';
import { FormConfigurationField } from '../ConfigurationForm/configs/types';
import { ConfigurationForm } from '../ConfigurationForm';

export interface BaseTabProps<T = Record<string, unknown>> {
  form: FormInstance;
  initialValues: T;
  fields: FormConfigurationField[];
  renderInput: (field: FormConfigurationField) => JSX.Element;
  className: string;
  onFinish?: (values: T, saveAndExit?: boolean) => void | Promise<void>;
  children?: React.ReactNode;
}

interface SharedTabProps<T = Record<string, unknown>> extends BaseTabProps<T> {}

export const SharedTab = <T = Record<string, unknown>,>({
  form,
  initialValues,
  fields,
  renderInput,
  className,
  onFinish,
  children,
}: SharedTabProps<T>) => {
  return (
    <ConfigurationForm
      form={form}
      initialValues={initialValues}
      fields={fields}
      renderInput={renderInput}
      className={className}
      onFinish={onFinish}
    >
      {children}
    </ConfigurationForm>
  );
};
